"use client";
import React from "react";
import NoResult from "@/components/errors/no-result";


export default function NotFound() {

    return (
            <NoResult showBackButton imageSrc = '/images/icons/error-404.svg' message = "خطای ۴۰۴: صفحه پیدا نشد!" />
    )
}
